import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const API = `${window.__BACKEND_URL__}/api`;

export const errorDetailText = (err, fallback = 'Request failed') => {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  return d.message || fallback;
};

const selectStyle = { background: '#0F1923', border: '1px solid #2D3748', color: '#E2E8F0' };

// Project (required) + optional Job under that project. Jobs without a project
// are offered under any project (the server keeps the selected project).
export const ProjectJobSelect = ({ token, projectId, jobId, onChange, compact = false, testIdPrefix = 'pj', showJob = true }) => {
  const [projects, setProjects] = useState([]);
  const [jobs, setJobs] = useState([]);
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  useEffect(() => {
    if (!token) return;
    Promise.all([
      axios.get(`${API}/projects/search?limit=100`, auth),
      axios.get(`${API}/company/general-work-project`, auth).catch(() => ({ data: { selectable: true } })),
    ]).then(([{ data }, gw]) => {
      let list = Array.isArray(data) ? data : [];
      if (gw.data?.selectable === false) list = list.filter((p) => !p.is_system); // company requires a real project
      list.sort((a, b) => (b.is_system ? 1 : 0) - (a.is_system ? 1 : 0));
      setProjects(list);
    }).catch(() => setProjects([]));
    if (showJob) {
      axios.get(`${API}/jobs`, auth)
        .then(({ data }) => {
          const list = Array.isArray(data) ? data : data?.jobs || [];
          setJobs(list.filter((j) => !j.deleted_at && !j.archived && !['completed', 'invoiced'].includes(j.status)));
        }).catch(() => setJobs([]));
    }
  }, [token]); // eslint-disable-line

  const projectJobs = useMemo(
    () => (projectId ? jobs.filter((j) => j.project_id === projectId || !j.project_id) : []),
    [jobs, projectId],
  );

  const cls = compact
    ? 'px-3 py-2 rounded-xl text-xs font-medium focus:outline-none max-w-[240px]'
    : 'w-full px-3 py-2.5 rounded-xl text-sm focus:outline-none';

  return (
    <>
      <select value={projectId || ''} className={cls} style={selectStyle} data-testid={`${testIdPrefix}-project-select`}
        onChange={(e) => onChange({ projectId: e.target.value || null, jobId: null })}>
        <option value="">Project (required)…</option>
        {projects.map((p) => (
          <option key={p.id} value={p.id}>{p.project_number} — {p.name}{p.customer_name ? ` · ${p.customer_name}` : ''}</option>
        ))}
      </select>
      {showJob && projectId && projectJobs.length > 0 && (
        <select value={jobId || ''} className={cls} style={selectStyle} data-testid={`${testIdPrefix}-job-select`}
          onChange={(e) => onChange({ projectId, jobId: e.target.value || null })}>
          <option value="">Job (optional)</option>
          {projectJobs.map((j) => (
            <option key={j.id} value={j.id}>{j.job_number ? `${j.job_number} — ` : ''}{j.title}</option>
          ))}
        </select>
      )}
    </>
  );
};

export default ProjectJobSelect;
